import Display from "../components/display/Display";
import Header from "../components/display/Header";
import Footer from "../components/footer/Footer";

const House = () => (
  <>
    <Header />
    <Display />
    <Footer />
  </>
);

export default House;
